// extracted by mini-css-extract-plugin
export default {"select":"LocalePicker_select__cPahq custom-select","dark":"LocalePicker_dark__xiBuS"};